import axios from "axios";
import store from "../../../../../../stores/application/index.js.erb";

const scholarshipCommentPath = `/scholarship/meeting/meetings`;

const get_token = () => {
    const token = document.querySelector('[name=csrf-token]').content;
    return axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
};

const showErrorMessage = () => {
    return store.dispatch("error_portfolio/addError", {
        type: "Error Server",
        message: "Ошибка сервера, попробуйте позже!",
        context: "Error Server",
        show: true
    });
};

const ScholarshipMeetingCommentApi = {

    async create(idMeeting, payload) {
        get_token();
        try {
            return await axios.post(`${scholarshipCommentPath}/${idMeeting}/comment`, {scholarship_comment: payload});
        } catch (e) {
            showErrorMessage();
            return null;
        }
    },

    async update(idMeeting, idComment, comment) {
        get_token();
        try {
            return await axios.put(`${scholarshipCommentPath}/${idMeeting}/comment/${idComment}`, {scholarship_comment:
                {comment: comment}
            });
        } catch (e) {
            showErrorMessage();
            return null;
        }
    },

    async addVoteComment(idMeeting, idComment, status, comment) {
        get_token();
        try {
            return await axios.post(`/scholarship/meeting/meetings/${idMeeting}/comment/${idComment}/votes`, {
                scholarship_votes: {
                    status: status,
                    comment: comment
                }
            });
        } catch (e) {
            showErrorMessage();
            return null;
        }
    },

    async updateVoteComment(idMeeting, idComment, idVote, comment) {
        get_token();
        try {
            return await axios.put(`/scholarship/meeting/meetings/${idMeeting}/comment/${idComment}/votes/${idVote}`, {
                scholarship_votes: {
                    comment: comment
                }
            });
        } catch (e) {
            showErrorMessage();
            return null;
        }
    },

}

export default ScholarshipMeetingCommentApi;